var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EBF9F5",
    width: 24,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#01B37A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.99 21.432c-2.175 0-4.041-.723-5.6-2.167-1.559-1.445-2.421-3.232-2.589-5.36a.598.598 0 0 1 .171-.48.646.646 0 0 1 .49-.205c.183 0 .34.065.468.194.13.13.21.293.24.49.167 1.75.897 3.213 2.19 4.391 1.292 1.179 2.835 1.768 4.63 1.768 1.9 0 3.516-.665 4.847-1.996 1.33-1.33 1.996-2.946 1.996-4.847 0-1.9-.647-3.516-1.94-4.847-1.292-1.33-2.888-1.995-4.79-1.995h-.501l1.186 1.186a.656.656 0 0 1 .205.479.656.656 0 0 1-.205.479.656.656 0 0 1-.479.205.656.656 0 0 1-.479-.205L9.435 6.127a.695.695 0 0 1-.16-.228.67.67 0 0 1-.045-.251.67.67 0 0 1 .045-.251.695.695 0 0 1 .16-.228l2.418-2.418a.619.619 0 0 1 .456-.183c.183 0 .342.061.48.183a.698.698 0 0 1 .182.479c0 .182-.061.334-.183.456l-1.323 1.323h.525c1.14 0 2.208.213 3.205.639a8.228 8.228 0 0 1 2.611 1.756 8.228 8.228 0 0 1 1.756 2.612c.426.996.64 2.064.64 3.204 0 1.14-.214 2.209-.64 3.205a8.228 8.228 0 0 1-1.756 2.612 8.228 8.228 0 0 1-2.611 1.756 8.066 8.066 0 0 1-3.205.639z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.8a1.85 1.85 0 0 1-1.36-.56 1.85 1.85 0 0 1-.558-1.358v-3.51a.803.803 0 0 1-.518-.267.794.794 0 0 1-.21-.55v-.728c0-.224.082-.418.246-.582a.795.795 0 0 1 .582-.245h3.636c.224 0 .418.082.582.245a.795.795 0 0 1 .245.582v.728c0 .212-.07.395-.209.55a.803.803 0 0 1-.518.268v3.509c0 .533-.188.986-.563 1.359-.376.373-.828.559-1.355.559zm0-.682a1.21 1.21 0 0 0 1.19-.936h-.917a.327.327 0 0 1-.337-.337c0-.096.032-.178.096-.245a.319.319 0 0 1 .24-.1h.964v-.545h-.963a.319.319 0 0 1-.241-.1.33.33 0 0 1-.096-.237.327.327 0 0 1 .336-.345h.964v-.546h-.963a.319.319 0 0 1-.241-.1.342.342 0 0 1-.096-.245.327.327 0 0 1 .337-.337h.963v-.663h-2.463v3.5c0 .345.12.638.359.877.24.24.529.36.868.36z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecollection);
export default __webpack_public_path__ + "static/media/recollection.484fbabd29be30900cbbccb5f5107d3d.svg";
export { ForwardRef as ReactComponent };